import { useTranslation } from '~shared/lib/i18n';
import { dayjs } from '~shared/lib/time';
import { Button, GlobusIcon } from '~shared/ui';

import { LocaleCodes } from '../../model';

export interface SetRegistrationViewProps {}

export const SetRegistrationView: React.FC<SetRegistrationViewProps> = () => {
  const { t, i18n } = useTranslation();
  const lang = i18n.language;

  const handleLocaleChange = (payload: string | number) => {
    i18n.changeLanguage(payload as string);
    dayjs.locale(payload as string);
  };

  return (
    <>
      <Button
        className={` border-none ${lang === 'ky' ? 'text-primary bg-[#F8F8F8]' : ''}`}
        onClick={() => handleLocaleChange(LocaleCodes.KYRGYZ)}
      >
        <GlobusIcon color={lang === 'ky' ? '#0ACD9A' : undefined} /> {t('auth:buttons.kg')}
      </Button>
      <Button
        className={` border-none ${lang === 'ru' ? 'text-primary bg-[#F8F8F8]' : ''}`}
        onClick={() => handleLocaleChange(LocaleCodes.RUSSIAN)}
      >
        <GlobusIcon color={lang === 'ru' ? '#0ACD9A' : undefined} /> {t('auth:buttons.ru')}
      </Button>
    </>
  );
};
